export {default as DARK_LOGO} from 'images/big-dark-logo.png';
export {default as GIFT_BOX} from 'images/gift-box.gif';
export {default as BR_VERIFIED} from 'images/bookmaker-stamp.png';
export {default as TABLE_LABEL_TYPES_FIRE} from 'images/fire.svg';
export {default as TABLE_LABEL_TYPES_CUP} from 'images/cup-table.svg';
